import { 
  GET_GAME_DASHBOARD_LOADING,
  GET_GAME_LIST,
  GET_GAME_LIST_REQUEST,
  UPDATE_GAME_LIST_REQUEST,
  CLEAR_GAME_LIST_REQUEST,
  GET_GAME_LIST_DROPDOWN,
  GET_GAME_DASHBOARD,
  UPDATE_GAME_DASHBOARD_REQUEST,
  CLEAR_GAME_DASHBOARD_REQUEST
} from "../actions/types"

const initialState = {
  loading: false,
  gameList: [],
  gameListRequest: {
    search: "",
    status: "all",
    startDate: null,
    endDate: null,
    gameType: 0
  },
  gameListDropdown: [],
  gameDashboard: {
    totalGame: 0,
    totalPlayer: 0,
    totalReward: 0,
    totalActive: 0,
    totalExpired: 0,
    totalPause: 0,
    playerDetail: []
  },
  gameDashboardRequest: {
    gameId: [],
    startDate: null,
    endDate: null
  }
}

const gameDashboardNew = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case GET_GAME_DASHBOARD_LOADING:
      return {
        ...state,
        loading: payload
      }
    case GET_GAME_LIST:
      return {
        ...state,
        gameList: payload
      }
    case GET_GAME_LIST_REQUEST:
      return {
        ...state,
        gameListRequest: {
          ...state.gameListRequest,
          search: payload.search,
          status: payload.status,
          startDate: payload.startDate,
          endDate: payload.endDate,
          gameType: payload.gameType
        }
      }
    case UPDATE_GAME_LIST_REQUEST:
      return {
        ...state,
        gameListRequest: {
          ...state.gameListRequest,
          [payload.name]: payload.value
        }
      }
    case CLEAR_GAME_LIST_REQUEST:
      return {
        ...state,
        gameListRequest: {
          ...state.gameListRequest,
          status: initialState.gameListRequest.status,
          startDate: initialState.gameListRequest.startDate,
          endDate: initialState.gameListRequest.endDate
        }
      }
    case GET_GAME_LIST_DROPDOWN:
      return {
        ...state,
        gameListDropdown: payload
      }
    case GET_GAME_DASHBOARD:
      return {
        ...state,
        gameDashboard: {
          ...state.gameDashboard,
          totalGame: payload.totalGame,
          totalPlayer: payload.totalPlayer,
          totalReward: payload.totalReward,
          totalActive: payload.totalActive,
          totalExpired: payload.totalExpired,
          totalPause: payload.totalPause,
          playerDetail: payload.playerDetail
        }
      }
    case UPDATE_GAME_DASHBOARD_REQUEST:
      return {
        ...state,
        gameDashboardRequest: {
          ...state.gameDashboardRequest,
          [payload.name]: payload.value
        }
      }
    case CLEAR_GAME_DASHBOARD_REQUEST:
      return {
        ...state,
        gameDashboardRequest: initialState.gameDashboardRequest
      }
    default:
      return state
  }
}

export default gameDashboardNew